import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';

import { fToNow } from 'src/utils/format-time';

import { CONFIG } from 'src/global-config';

import { Label } from 'src/components/label';
import { FileThumbnail } from 'src/components/file-thumbnail';

// ----------------------------------------------------------------------

export type INotificationItem = {
  _id: string;
  createdAt: string;
  isRead: boolean;
  user: {
    _id: string;
    displayImage: string;
    displayName: string;
  };
  updatedAt: string;
  uid: string;
  notificationType: string;
  notificationPreview: {
    content: string;
    data: {
      target: string;
      targetId: string;
      uid: string;
    };
    name: string;
    subject: string;
  };
};

export type NotificationItemProps = {
  notification: INotificationItem;
};

export function NotificationItem(props: NotificationItemProps) {
  const renderAvatar = () => (
    <ListItemAvatar>
      {props.notification.user && (
        <Avatar src={props.notification.user.displayImage} sx={{ bgcolor: 'secondary.main' }} />
      )}
    </ListItemAvatar>
  );

  const renderText = () => (
    <ListItemText
      disableTypography
      primary={
        <Typography variant="body1" fontWeight={600}>
          {props.notification?.notificationPreview?.content}
        </Typography>
      }
      // secondary={
      //   <Typography variant="caption">
      //     {props.notification?.notificationPreview?.content}
      //   </Typography>
      // }
    />
  );

  const renderUnReadBadge = () =>
    !props.notification.isRead && (
      <Box
        sx={{
          top: 26,
          width: 8,
          height: 8,
          right: 20,
          borderRadius: '50%',
          bgcolor: 'info.main',
          position: 'absolute',
        }}
      />
    );

  return (
    <ListItemButton
      disableRipple
      sx={[
        (theme) => ({
          p: 2.5,
          alignItems: 'flex-start',
          borderBottom: `dashed 1px ${theme.vars.palette.divider}`,
        }),
      ]}
    >
      {renderUnReadBadge()}
      {renderAvatar()}

      <Box sx={{ flex: '1 1 auto' }}>{renderText()}</Box>
    </ListItemButton>
  );
}
